<template>
    <div class="container d-flex justify-content-end mt-3">

      <vs-select v-model="$i18n.locale" class="mt-3">

        <vs-select-item 
          v-for="(lang, i) in langs"
          :key="`lang-${i}`"
          :value="lang.code" 
          :text="lang.lang">
        </vs-select-item>
        </vs-select>
      
    </div>
  </template>

  <script>

  export default {
    name: 'SwitchLocale',
    data() {
      return { langs: [
        {code : 'en', lang: 'English'},
        {code : 'ro', lang: 'Română'},
        {code : 'it', lang: 'Italian'},
        {code : 'es', lang: 'Español'},
        {code : 'de', lang: 'Deutsch'},
        {code : 'fr', lang: 'Français'},
        {code : 'ru', lang: 'Русский'},
      ]}        
    }
  }
  </script>
  <style>
  select {
      width: 150px;
      line-height: 49px;
      height: 38px;
      font-size: 22px;
      outline: 0;
      margin-bottom: 15px;
  }
  
  </style>